import React from 'react'
// libs
import styled, { css } from 'styled-components'
// components
import { Button as ButtonOrigin } from 'components/Modals/PlanItems/components/CompleteReview/views'
import { Paper as PaperOrigin, Scrollbar } from 'components/UI'
// views
import ArrowForwardIcon from '@mui/icons-material/ExpandMore'

const Paper = styled(({ isTaskExist, children, ...props }) => <PaperOrigin {...props}>{children}</PaperOrigin>)`
  && {
    cursor: pointer;
    width: 100%;

    @media (max-width: 768px) {
      width: 100%;
      border-radius: 0;
    }

    ${({ isTaskExist }) =>
      isTaskExist &&
      css`
        border-radius: 0 35px 35px 0;

        @media (max-width: 768px) {
          height: 140px;
          margin-bottom: 16px;

          & > div {
            height: 100%;
          }
        }
      `}
  }
`

const CollapseWrapper = styled('div')`
  align-items: center;
  display: flex;
  height: 58px;
  margin: 16px 0;
`

const CollapseIcon = styled(({ isCollapsed, ...props }) => <ArrowForwardIcon {...props} />)`
  && {
    cursor: pointer;
    font-size: 14px;
    height: 40px;
    margin: 0 7px;
    width: 25px;

    ${({ isCollapsed }) =>
      isCollapsed &&
      css`
        transition: 0.1s transform ease-in-out;
        transform: rotate(-90deg);
      `}
  }
`

// @ts-ignore
const Button = styled(ButtonOrigin)`
  height: 58px;
  margin: 0;
  width: 125px;

  @media (max-width: 768px) {
    width: 100%;
    height: 40px;
    margin: 0 50px !important;
    border-radius: 25px;

    > div {
      width: 100%;
    }
  }
`

const ButtonLabel = styled('div')`
  font-size: 14px;
  text-align: center;
  width: 90px;
`

const ProgressIndicator = styled('div')`
  font-weight: bold;
`

const TasksCount = styled('div')`
  margin-left: 8px;
`

const AvatarWrapper = styled('div')`
  display: flex;
  margin-right: 16px;

  & > span {
    margin-right: -10px;
    position: relative;
  }

  div {
    height: 32px;
    font-size: 14px;
    width: 32px;
  }
`

const TasksWrapper = styled(Scrollbar)<{ $isGroupedByPlan: boolean; $isCollapsed: boolean }>`
  @media (max-width: 768px) {
    display: grid;
    grid-gap: 25px;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    padding: ${({ $isCollapsed }) => ($isCollapsed ? 0 : '0 0 16px 0')};

    ${({ $isGroupedByPlan }) =>
      $isGroupedByPlan &&
      css`
        grid-auto-flow: column;
      `}
  }
`

const Wrapper = styled.div``

export {
  AvatarWrapper,
  Button,
  ButtonLabel,
  CollapseIcon,
  CollapseWrapper,
  Paper,
  ProgressIndicator,
  TasksCount,
  TasksWrapper,
  Wrapper
}
